export interface MetricDefinition {
  key: keyof UsageMetrics;
  label: string;
  description?: string;
  defaultValue: number;
  format?: 'number' | 'currency' | 'percentage';
}

export const USAGE_METRICS_CONFIG: MetricDefinition[] = [
  {
    key: 'totalInvitedClients',
    label: 'Invited (Pending Intake)',
    description:
      'Clients who have been invited but have not yet completed the intake questionnaire',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalClientsWithSurveysCompleted',
    label: 'Surveys Completed',
    description:
      'Clients who have fully completed all required intake questionnaires',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalClientsWithApplicationsStarted',
    label: 'Clients With Applications',
    description:
      'Clients with at least one insurance application initiated but not necessarily submitted',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalClientPolicies',
    label: 'Client Policies',
    description:
      'Total number of insurance policies modeled or added within client plans',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalMonthlyRecurringPremiums',
    label: 'Lifetime Premiums',
    description:
      'Aggregate premiums for lifetime pay policies expressed as a monthly equivalent',
    defaultValue: 0,
    format: 'currency',
  },
  {
    key: 'totalFixedPremiums',
    label: 'Fixed Premiums',
    description:
      'Aggregate premiums for single pay and limited pay policies, including 5 pay and 10 pay structures',
    defaultValue: 0,
    format: 'currency',
  },
  {
    key: 'totalClientsWithFinancePlans',
    label: 'LTC Plans Created',
    description:
      'Clients for whom a long term care funding plan has been created',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalApplicationsSubmitted',
    label: 'Applications Submitted',
    description:
      'Insurance applications formally submitted to carriers or BGAs',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'advisorActivityScore',
    label: 'Advisor Activity Score',
    description:
      'Count of tracked advisor interactions across the platform during the prior 30 day period',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalAdvisorLogins',
    label: 'Advisor Logins',
    description:
      'Number of unique calendar days on which the advisor logged in',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'advisorOnboardingPercentage',
    label: 'Onboarding Progress',
    description:
      'Percentage of required onboarding steps completed by the advisor',
    defaultValue: 0,
    format: 'percentage',
  },
];

// Helper to create empty metrics object
export function createEmptyMetrics(): UsageMetrics {
  return USAGE_METRICS_CONFIG.reduce((acc, metric) => {
    acc[metric.key] = metric.defaultValue;
    return acc;
  }, {} as UsageMetrics);
}

// Helper for generic aggregation
export function aggregateMetrics(advisorMetrics: UsageMetrics[]): UsageMetrics {
  return USAGE_METRICS_CONFIG.reduce((acc, metric) => {
    acc[metric.key] = advisorMetrics.reduce((sum, advisor) => sum + advisor[metric.key], 0);
    return acc;
  }, {} as UsageMetrics);
}
